/* Router */
class OrderRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Order';
        const model = App.Models.Order;
        const collectionClass = App.Collections.Orders;

        super(entityName, model, collectionClass);
    }
}

App.Routers.Order = OrderRouter;
